import React from 'react';
import {observer} from 'mobx-react-lite';
import {Container, Main} from '../../../patterns';
import {ViewStore} from '../base/view-store';
import {GenericError} from '../base/GenericError';

interface IWebappBaseProps {
    store: ViewStore;
    title: string;
    renderChildren: () => React.ReactNode;
}

export const WebappBase = observer((props: IWebappBaseProps): JSX.Element => {
    if (props.store.state === 'loading') {
        return (
            <Main isLoading={true}><Container><h2>{props.title}</h2></Container></Main>
        );
    }

    if (props.store.state === 'error') {
        return (
            <Main><GenericError/></Main>
        );
    }

    return (
        <Main isLoading={props.store.state === 'refreshing'}>{props.renderChildren()}</Main>
    );
});
